module.exports = __webpack_public_path__ + "img/DB4-1920_06.eb2e55fd.jpg";